/** @format */
import React from 'react';

import {
    CalcServicePromoType,
    CalcServicePromotionRate,
} from '@toucan/client/global/calculation-service';
import { PromotionSummaryType } from '@toucan/client/global/transaction/config/constants';

/**
 * An interface that can be used to extend an emotion styled component props
 * interface.
 */
// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface EmotionDynamicElement {
    /**
     * The html element to render the component as. Overwrites the element type
     * that the component was created with.
     */
    as: React.ElementType;
}

export enum ProductCategoryVariant {
    BRAND = 'brands',
    LIST = 'list',
}
// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface ProductCategory {
    url: string;
    templatePath: string;
    title: string;
    id: number | null;
    categories?: ProductCategory[];
    variant?: ProductCategoryVariant;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface PromoCode {
    /**
     * An id for the promo code
     */
    id: string;

    /**
     * The type of promo code
     */
    type: PromotionSummaryType | CalcServicePromoType;

    /**
     * The code that is entered by the user
     */

    code: string;

    /**
     * Text that is displayed to the user. Contains a short description of
     * the promo code
     */
    displayName: string;

    /**
     * Value of the promo code
     */
    value?: number;

    /**
     * Formatted value of the promo code
     */
    formattedValue?: string;

    /**
     * Error to display next to the promo code
     */
    error?: string;

    /**
     * In the case of importing from a calc service response, we also preserve the rate value
     */
    rate?: CalcServicePromotionRate;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface WithMountCallback {
    onMountCallback?: () => void;
}
